var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleComponentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.0018V7.99739C20.9997 7.73541 20.9308 7.47807 20.8001 7.25101C20.6694 7.02394 20.4815 6.83506 20.2552 6.70317L13.1302 2.55661C12.7869 2.35675 12.3968 2.25146 11.9995 2.25146C11.6023 2.25146 11.2122 2.35675 10.8689 2.55661L3.74484 6.70317C3.51848 6.83506 3.33061 7.02394 3.19993 7.25101C3.06925 7.47807 3.00032 7.73541 3 7.99739V16.0018C3.00016 16.2639 3.06901 16.5214 3.1997 16.7487C3.33038 16.9759 3.51834 17.1649 3.74484 17.2969L10.8698 21.4435C11.2132 21.6431 11.6033 21.7482 12.0005 21.7482C12.3976 21.7482 12.7877 21.6431 13.1311 21.4435L20.2561 17.2969C20.4824 17.1648 20.6702 16.9758 20.8007 16.7485C20.9312 16.5213 20.9999 16.2638 21 16.0018Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 7.21826L12 12.3745M12 12.3745L20.7656 7.21826M12 12.3745V21.7495",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleComponentIcon);
export default __webpack_public_path__ + "static/media/module-component-icon.e524fc36088bc27476e21ef80090a5d0.svg";
export { ForwardRef as ReactComponent };